import ApprovalLevel from 'pages/System/SetApprovalPage/ApprovalAdjusterPage/components/ApprovalLevel';

interface IApprovalLevelsProps {
  level: number;
}

const ApprovalLevels = ({ level }: IApprovalLevelsProps) => {
  return (
    <div className="pt-3 pb-10">
      {new Array(level).fill(0).map((_, index) => (
        <ApprovalLevel level={index + 1} key={index} />
      ))}
    </div>
  );
};

export default ApprovalLevels;
